export class ResetStates {
  public static readonly type = '[Project] ResetStates';
}
